// @flow

/* -----------------Globals--------------- */
import React from 'react';

/* -----------------Third parties--------------- */
import { createWrapper } from 'next-redux-wrapper';

/* -----------------Configs--------------- */
import configureStore from 'common/src/config/redux/configure-store-web';

/* -----------------Props--------------- */
type Props = {
  children: *,
}

const wrapper = createWrapper(configureStore);

/* -----------------Component--------------- */
const ReduxContainer = (props: Props) => {
  const {
    children,
  } = props;
  return (
    <>
      {children}
    </>
  );
};

/* -----------------exports--------------- */
export default wrapper.withRedux(ReduxContainer);
